import type { ReactNode } from "react";
import { researchProjects } from "./branding-config";
import foresightLogo from "./assets/foresight.png";
import foresightWhiteLogo from "./assets/foresight-white.png";
import synergiseLogo from "./assets/synergise.svg";

/** Official, unmodified artwork. Application-use approval confirmed by the owner. */
export function ProjectIdentity({ project, onDark = false }: { readonly project: (typeof researchProjects)[number]; readonly onDark?: boolean }): ReactNode {
  const hasLightArtwork = onDark && project.id === "foresight";
  return (
    <span className={`c3i-projects__identity${hasLightArtwork ? " c3i-projects__identity--on-dark" : ""}`}>
      <img alt={project.name} className={`c3i-project-logo c3i-project-logo--${project.id}`} height={project.id === "foresight" ? 176 : 500.57} src={project.id === "foresight" ? (hasLightArtwork ? foresightWhiteLogo : foresightLogo) : synergiseLogo} width={project.id === "foresight" ? 930 : 841.89} />
    </span>
  );
}
